import styled, { css } from 'styled-components';
import { Flex } from '../flex/index.js';
import { Label } from '../label/index.js';
import { Paragraph } from '../paragraph/index.js';
import { suppressProps } from '../../utils/index.js';
export const FieldElement = styled(Flex)
    .attrs({
    direction: 'column',
})
    .withConfig(suppressProps('fullWidth'))(({ fullWidth }) => css `
    width: ${fullWidth && '100%'};
  `);
export const FieldLabel = styled(Label)(({ theme, loading }) => css `
    margin-bottom: ${theme.space.x1};
    ${loading === 'fullWidth'
    ? css `
          & span {
            max-width: ${theme.sizes.x16};
          }
        `
    : css ``}
  `);
export const FieldLabelAsterisk = styled.span.attrs({
    'aria-hidden': 'true',
    children: '*',
})(({ theme }) => css `
    color: ${theme.colors.text.error};
    vertical-align: super;
    line-height: 0;
    margin: ${theme.space.x0} ${theme.space.x1};
  `);
export const FooterElement = styled.div ``;
export const ErrorElement = styled(Paragraph).attrs({
    variant: 'smallCompact',
    color: 'error',
})(({ theme }) => css `
    margin-top: ${theme.space.x1};
  `);
export const DescriptionElement = styled(Paragraph).attrs({
    variant: 'smallCompact',
    color: 'secondary',
})(({ theme, loading }) => css `
    margin-top: ${theme.space.x1};
    ${loading === 'fullWidth'
    ? css `
          & span {
            max-width: ${theme.sizes.x16};
          }
        `
    : css ``}
  `);
//# sourceMappingURL=field.styles.js.map